import React, { useEffect, useState } from 'react'

import Box from '@mui/material/Box'

import ProgressStepper from './ProgressStepper'
import Section1 from './sections/Section1'
import Section2 from './sections/Section2'
import Section3 from './sections/Section3'
import Section4 from './sections/Section4'
import Section5 from './sections/Section5'
import Section6 from './sections/Section6'
import Section7 from './sections/Section7'
import Section8 from './sections/Section8'
import Section9 from './sections/Section9'

import api from '../services/api'
import { Form, StateConfig } from '../types/form'

const SECTIONS = {
    1: Section1,
    2: Section2,
    3: Section3,
    4: Section4,
    5: Section5,
    6: Section6,
    7: Section7,
    8: Section8,
    9: Section9,
}


const CvForm = () => {

    /**
     * VALUES
     */
    const [values, setValues] = useState<Form>({
        driver_type: '1',
        residence_city: '',
        experience_months: '',
        cnh_type: '',
        experiences: [{
            company: '',
            vehicle_types: [],
            start_date: null,
            end_date: null,
            resignation_reason: '',
            other_vehicle_types: '',
        }],
        traveled_regions: [],
        nationality: null,
        cpf: '',
        full_name: '',
        email: '',
        birth_date: null,
        phone1: '',
        phone2: '',
        ex_employee: false,
        ex_employee_start_date: null,
        ex_employee_end_date: null,
        ex_employee_resignation_reason: '',
    })
    const [files, setFiles] = useState<File[]>([])
    const [isRejected, setIsRejected] = useState(false)
    const [rejectReason, setRejectReason] = useState<number | null>(null)

    /**
     * STEPPER
     */
    const [step, setStep] = useState(1)
    const handleNextStep = () => {
        setStep(s => s + 1)
    }

    // @ts-ignore
    const ActiveSection = SECTIONS[step]

    /**
     * STATE CONFIG
     */
    const [enabledStates, setEnabledStates] = useState<StateConfig[]>([])

    useEffect(() => {
        api.get(`v0/recruitment/enabled-states/search/`).then(res => {
            setEnabledStates(res.data.results)
        })
    }, [])

    return (
        <Box className={'form-container'} pb={5} sx={{ overflowY: 'auto' }}>
            <ProgressStepper step={step} setStep={setStep} />
            <ActiveSection
                handleNext={handleNextStep}
                values={values}
                setValues={setValues}
                files={files}
                setFiles={setFiles}
                enabledStates={enabledStates}
                isRejected={isRejected}
                setIsRejected={setIsRejected}
                rejectReason={rejectReason}
                setRejectReason={setRejectReason}
            />
        </Box>
    )
}

export default CvForm
